export class StringManipulationHelper {
    public static cleanUrlQueryParamsAndFragments(str: string): string {
        return str.replace(/(?:#|\?).+/, "");
    }

    public static cleanSlashes(str: string): string {
        return str.split("/").join("");
    }
}